import {Injectable, Type} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MvsCrudService} from 'features/core/shared/service/crud/mvs-crud.service';
import {MvsCrudModeEnum} from 'features/core/shared/service/crud/mvs-crud-mode.enum';

/**
* Thin CRUD service for cn.CommissionExpectation.
*
* Used by:
*  - CnRulePreviewComponent to fetch the CommissionExpectation (and its calculationTrace)
*    for a (rule × example contract) preview (FR-17),
*  - implicitly by the data-quality panel via the entity registry (FR-15).
*/
@Injectable({
    providedIn: 'root'
})
export class CommissionExpectationService extends MvsCrudService {

    constructor(protected override http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/cn/commissionExpectations');
    }

    getObjectIcon(): string {
        return 'fa-solid fa-magnifying-glass-chart';
    }

    /**
     * Human-readable entity labels [singular, plural].
     * Element [0] is the singular label consumed by the core CRUD dialog title
     * (MvsCoreService.getObjectLabels(objectType)?.[0]) so the create/edit dialog
     * shows "Provisionserwartung anlegen" / "Provisionserwartung bearbeiten"
     * instead of the literal field name. These are entity labels, NOT field names.
     */
    getObjectLabels(): string[] {
        return ['Provisionserwartung', 'Provisionserwartungen'];
    }

    /**
    * No dedicated object component for the expectation aggregate — detail/edit mode
    * falls back to the metadata-driven generic form (returns null).
    */
    getObjectComponent(mode: MvsCrudModeEnum = MvsCrudModeEnum.update): Type<any> {
        return null;
    }

}
